<template>
  <svg
    class="custom-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="17"
    viewBox="0 0 15 17"
    fill="none"
  >
    <path
      d="M7.49993 0C5.19874 0 3.33318 1.90267 3.33318 4.24976C3.33318 6.59701 5.19866 8.49989 7.49993 8.49989C9.80119 8.49989 11.6667 6.59708 11.6667 4.24976C11.6667 1.90252 9.80119 0 7.49993 0Z"
    />
    <path
      d="M5.83316 9.34984C2.61151 9.34984 0 12.0138 0 15.3001V16.15C0 16.6195 0.373032 17 0.833278 17H14.1667C14.627 17 15 16.6195 15 16.15V15.3001C15 12.014 12.3884 9.34984 9.16684 9.34984H5.83316Z"
    />
  </svg>
</template>
